import React from 'react';
import { Tooltip } from 'react-tooltip';

interface ButtonProp {
  label?: string;
  icon?: React.ReactNode;
  color?: string;
  hoverBorderColor?: string;
  colorHover?: string;
  textColor?: string;
  textColorHover?: string;
  height?: string;
  width?: string;
  shadow?: string;
  textSize?: string;
  padding?: string;
  tooltip?: string;
  font?: string;
  roundedRadius?: string;
  disable?: boolean;
  onClick: () => void;
}

const Button: React.FC<ButtonProp> = ( {
  label,
  tooltip,
  icon,
  height = 'w-auto',
  width = 'w-auto',
  shadow = 'shadow-md',
  disable = false,
  color = 'bg-green-base',
  font = 'font-semibold',
  hoverBorderColor = 'hover:border-green-base',
  colorHover = 'hover:bg-green-800',
  roundedRadius = 'rounded-md',
  textColor = 'text-green-800',
  textColorHover = 'hover:text-green-base',
  textSize = 'text-base',
  padding = 'px-2 py-2',
  onClick,
} ) => {
  return (
    <div className="flex h-fit w-fit">
      <div
        className={`
          flex self-center gap-4 items-center group ${width} ${height} ${font} ${shadow} ${roundedRadius} ${textSize} ${textColor} border-2 select-none ${padding}
          ${disable ? 'cursor-not-allowed bg-gray-300 border-gray-300' : `cursor-pointer ${color} border-transparent ${colorHover} ${textColorHover} ${hoverBorderColor} trans-fast active:scale-95`}
          ${label && 'px-2 py-1'}
          ${label && !icon && 'aspect-square flex-center'}
          ${!label && icon && 'aspect-square'}
        `}
        onClick={() => {
          if ( !disable ) {
            onClick();
          }
        }}
      >
        {icon && <div>{icon}</div>}
        {label && <p className="whitespace-nowrap">{label}</p>}
      </div>
      { tooltip ?
        <Tooltip
          id={`${label}-tooltip`}
          className='z-30'
          place="right"
        >
          { tooltip }
        </Tooltip>
        :
        null
      }
    </div>
  );
};

export default Button;
